import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Button
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";

import { Helmet } from "react-helmet-async";

import { FiChevronDown } from "react-icons/fi";

import useStyles from "./styles";
import TextInput from "Components/TextInput";
import Spinner from "Components/Spinner";

import actions from "store/actions";

import _ from "lodash";

import { SubscriptionCreateState } from "store/reducers/subscription/create";

import ls from "Localization";
import { State } from "store/reducers";
import { SubscriptionStatus } from "Types/Subscription";
import AutoComplete from "Components/AutoComplete";
import { UserState } from "store/reducers/user";
import { MONEY } from "Components/NumberFormat";
import Select from "Components/Select";
import { PlanState } from "store/reducers/plan";
import { PaymentMethodState } from "store/reducers/paymentMethod";
import { DatePicker } from "@mui/x-date-pickers";
import { useNavigate } from "react-router-dom";

let debounceFindUser: (() => any) & _.Cancelable;

function SubscriptionCreate() {
	const navigate = useNavigate();
	const dispatch = useDispatch<any>();
	const classes = useStyles({});

	useEffect(() => {
		dispatch(actions.subscription.create.clearValues());
		dispatch(actions.plan.getPlans());
		dispatch(actions.paymentMethod.getPaymentMethods());
	}, [dispatch]);

	const [showInfoPanel, setShowInfoPanel] = useState(true);

	const {
		loading,
		errors,
		description,
		value,
		status,
		plan,
		paymentMethod,
		firstPayment,
		discount,
		installment,
		installmentInterval
	}: any = useSelector<State, SubscriptionCreateState>(
		s => s.subscriptionCreate
	);

	const { items: plans } = useSelector<State, PlanState>(s => s.plan);
	const { items: paymentMethods } = useSelector<State, PaymentMethodState>(
		s => s.paymentMethod
	);

	const { loading: userLoading } = useSelector<State, UserState>(s => s.user);

	const handleChange = (id: string, value: any) => {
		const v: any = { [id]: value };

		if (id === "plan") {
			const plan = plans.find(c => c._id === value);
			v.value = plan.value / 100.0;
			v.discount = plan.discount / 100.0;
			v.installment = plan.installment;
			v.installmentInterval = plan.installmentInterval;
		}

		dispatch(actions.subscription.create.setValue(v));
	};

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		dispatch(
			actions.subscription.create.createSubscription(err => {
				if (err) {
					console.log(err);
					if (err.code) {
						alert(err.code);
					} else if (typeof err === "string") alert(err);
					else alert(JSON.stringify(err));
				} else {
					navigate("/Dashboard/Subscriptions");
				}
			})
		);
	};

	const findUser = (name: any, callback: any) => {
		if (name.length >= 3) {
			if (debounceFindUser) debounceFindUser.cancel();

			debounceFindUser = _.debounce(() => {
				dispatch(
					actions.user.getUsers(
						0,
						10,
						`&filters[searchText]=${name}&filters[roles]=mei`,
						undefined,
						false,
						false,
						(errors, models) => {
							if (models) {
								callback(
									models.map(c => ({
										id: c._id,
										label: `${c.name} ${c.lastname}`
									}))
								);
							} else {
								callback([]);
							}
						}
					)
				);
			}, 1000);

			debounceFindUser();
		}
	};

	const ls2: any = ls;

	return (
		<form onSubmit={handleSubmit} noValidate>
			<Helmet>
				<title>
					{ls.subscriptionCreate} | {ls.appName}
				</title>
			</Helmet>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Accordion
						TransitionProps={{ unmountOnExit: true }}
						expanded={showInfoPanel}
						onChange={() => setShowInfoPanel(prev => !prev)}
					>
						<AccordionSummary
							expandIcon={<FiChevronDown />}
							aria-controls="finishes-content"
							id="finishes-header"
						>
							<Typography className={classes.heading} variant="h6">
								{ls.subscriptionCreate}
							</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Grid container spacing={2}>
								<Grid item xs={12} sm={6} md={4} lg={3}>
									<AutoComplete
										id="user"
										name="user"
										errors={errors}
										onChange={handleChange}
										loadOptions={findUser}
										loading={userLoading}
										filterOptions={(options: any, state: any) => {
											return options;
										}}
									/>
								</Grid>

								<Grid item xs={12} sm={6} md={4} lg={3}>
									<Select
										errors={errors}
										id="plan"
										name="plan"
										value={plan as string}
										required
										onChange={handleChange}
										options={[
											{ id: "", value: ls.noneSelectedText, disabled: true },
											...plans.map(c => ({
												id: c._id,
												value: c.name
											}))
										]}
									/>
								</Grid>

								<Grid item xs={12} sm={6} md={4} lg={3}>
									<TextInput
										errors={errors}
										id="value"
										name="value"
										value={value}
										required
										onChange={handleChange}
										InputProps={{
											inputComponent: MONEY
										}}
									/>
								</Grid>
								<Grid item xs={12} sm={6} md={4} lg={3}>
									<TextInput
										errors={errors}
										id="discount"
										name="discount"
										value={discount}
										onChange={handleChange}
										InputProps={{
											inputComponent: MONEY
										}}
									/>
								</Grid>
								<Grid item xs={12} sm={6} md={4} lg={3}>
									<TextInput
										errors={errors}
										id="installment"
										name="installment"
										value={installment}
										onChange={handleChange}
										type="number"
										InputProps={{
											inputProps: {
												step: 1,
												min: 1,
												max: 12
											}
										}}
									/>
								</Grid>

								{+installment > 1 && (
									<Grid item xs={12} sm={6} md={4} lg={3}>
										<Select
											errors={errors}
											id="installmentInterval"
											name="installmentInterval"
											value={installmentInterval.toString()}
											required
											onChange={handleChange}
											options={[
												{ id: "", value: ls.noneSelectedText, disabled: true },
												{
													id: "15",
													value: "15 dias"
												},
												{
													id: "30",
													value: "30 dias"
												}
											]}
										/>
									</Grid>
								)}

								<Grid item xs={12} sm={6} md={4} lg={3}>
									<DatePicker
										value={firstPayment}
										onChange={date => handleChange("firstPayment", date)}
										format={ls.dateFormatShort}
										label={ls.firstPayment}
										// emptyLabel="Selecione uma data"
									/>
								</Grid>

								<Grid item xs={12} sm={6} md={4} lg={3}>
									<Select
										errors={errors}
										id="paymentMethod"
										name="paymentMethod"
										value={paymentMethod as string}
										required
										onChange={handleChange}
										options={[
											{ id: "", value: ls.noneSelectedText, disabled: true },
											...paymentMethods.map(c => ({
												id: c._id,
												value: c.name
											}))
										]}
									/>
								</Grid>

								<Grid item xs={12} sm={6} md={4} lg={3}>
									<Select
										errors={errors}
										id="status"
										name="status"
										value={status.toString()}
										required
										onChange={handleChange}
										options={[
											{ id: "", value: ls.noneSelectedText, disabled: true },
											...Object.keys(SubscriptionStatus)
												.filter(c => !isNaN(+c))
												.map((c: any) => ({
													id: c,
													value: ls2[SubscriptionStatus[c]]
												}))
										]}
									/>
								</Grid>

								<Grid item xs={12}>
									<TextInput
										errors={errors}
										id="description"
										name="description"
										value={description}
										onChange={handleChange}
									/>
								</Grid>
							</Grid>
						</AccordionDetails>
					</Accordion>
				</Grid>

				<Grid item xs={12}>
					<Grid container justifyContent="flex-end">
						<Grid item>
							<Button
								disabled={loading}
								variant="contained"
								color="secondary"
								type="submit"
							>
								Salvar
								{loading && <Spinner size={20} style={{ marginLeft: 16 }} />}
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</form>
	);
}

export default SubscriptionCreate;
